import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  estrai: (immagine) => client.post("/assegni/estrai", { immagine }).then((r) => r.data),
  crea: (data) => client.post("/assegni", data).then((r) => r.data),
  lista: (stato) => client.get("/assegni", { params: stato ? { stato } : {} }).then((r) => r.data),
  dettaglio: (id) => client.get(`/assegni/${id}`).then((r) => r.data),
  aggiorna: (id, data) => client.put(`/assegni/${id}`, data).then((r) => r.data),
  elimina: (id) => client.delete(`/assegni/${id}`).then((r) => r.data),
  scadenze: () => client.get("/assegni/scadenze").then((r) => r.data),
  notifiche: () => client.get("/notifiche").then((r) => r.data),
  stats: () => client.get("/stats").then((r) => r.data),
  eliminaMultipli: (ids) => client.post("/assegni/elimina-multipli", { ids }).then((r) => r.data),
};

export const formatEuro = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v);
};

export const formatData = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return d;
  }
};

export const STATI = {
  ricevuto: { label: "Ricevuto", color: "bg-[#4B6B4E] text-white" },
  girato: { label: "Girato", color: "bg-[#D98A2C] text-white" },
  incassato: { label: "Incassato", color: "bg-[#5C5F58] text-white" },
};
